export default __webpack_public_path__ + "static/media/icon_settings.d85728a4.svg";